import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";

const DAY = 86400000;

export default function RenewReminder({ billing }) {
  if (!billing || billing.pending) return null;
  const soon = (billing.children || [])
    .map((c) => ({ ...c, end: c.paid_subjects?.length ? c.paid_until : c.reading_only ? c.reading_paid.map((l) => c.reading_until[l]).sort()[0] : null }))
    .filter((c) => c.end)
    .map((c) => ({ ...c, left: Math.floor((new Date(c.end) - Date.now()) / DAY) }))
    .filter((c) => c.left >= 0 && c.left <= 7);
  if (!soon.length) return null;
  return (
    <div className="nb-card bg-amber-50 border-2 border-slate-900 p-4 mb-6 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="renew-reminder">
      <RefreshCw className="text-amber-600 shrink-0" size={26} />
      <div className="flex-1">
        <p className="font-bold" data-testid="renew-reminder-title">Your monthly plan ends soon</p>
        <p className="text-slate-600 text-sm" data-testid="renew-reminder-details">
          {soon.map((c) => `${c.name}: ${c.left === 0 ? "ends today" : `${c.left} day${c.left > 1 ? "s" : ""} left`} (until ${new Date(c.end).toLocaleDateString()})`).join(" · ")}.
          {" "}Renew the same plan or switch to another one: Rs 200, Rs 500, Rs 800 or the Holiday Pack.
        </p>
      </div>
      <Link to="/pricing" className="shrink-0 rounded-full bg-slate-900 text-white px-4 py-2 text-sm font-semibold hover:bg-slate-800" data-testid="renew-reminder-btn">Renew / change plan</Link>
    </div>
  );
}
